import React from "react";

import cx from "classnames";

import styles from "./HorizontalDivider.module.css";

type HorizontalDividerProps = React.HTMLProps<HTMLDivElement> & { contents?: boolean };

export default class HorizontalDivider extends React.Component<HorizontalDividerProps> {
	render() {
		const { contents, className, ...rest } = this.props;
		return <div {...rest} className={cx(styles.horizontalDivider, className, { [styles.contents]: contents })} />;
	}
}
